// Collega il webapp al guscio nativo (heyjob-app): registra il push token del
// device e gestisce la navigazione richiesta dal nativo (tap su notifica).
// Non renderizza nulla; nel browser è un no-op.

import {useRef, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {useAuthContext} from "../auth/hooks/index";
import EmployeeService from "../services/EmployeeService";
import {nativeInfo, isNativeApp, onNativeMessage, requestFromNative} from "../utils/native-bridge";

export default function NativeBridge() {
  const {user} = useAuthContext();
  const navigate = useNavigate();
  const pushRegistered = useRef(false);

  // Tap su una notifica → naviga alla rotta indicata dal nativo
  useEffect(() => {
    if (!isNativeApp()) return undefined;
    return onNativeMessage((message) => {
      if (message?.type === 'NAVIGATE' && typeof message.path === 'string' && message.path) {
        navigate(message.path);
      }
    });
  }, [navigate]);

  // Push token: solo a utente autenticato (la PUT richiede il bearer Cognito)
  useEffect(() => {
    if (!isNativeApp() || nativeInfo()?.capabilities?.deviceRegistration || !user?.data || pushRegistered.current) return;
    pushRegistered.current = true;

    // il permesso notifiche può richiedere tempo (prompt di sistema)
    requestFromNative({type: 'REGISTER_PUSH'}, {timeout: 60000})
      .then((res) => {
        if (res.type === 'PUSH_TOKEN' && res.token) {
          return EmployeeService.updateEmployeeToken(res.token);
        }
        console.warn('Push non registrato:', res.reason ?? res.type);
        return null;
      })
      .catch((e) => {
        // non è un'azione dell'utente: nessuna snackbar, solo log
        console.warn('Registrazione push token fallita', e);
        pushRegistered.current = false;
      });
  }, [user?.data]);

  return null;
}
